import angular from 'angular';
import constants from 'app/constants';
import {
  pmDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog
} from 'app/components/global';
import controller from './new-recommended-changes-dialog.controller';
import template from './new-recommended-changes-dialog.html';
import syncNewRecommended from '../syncNewRecommended';
import approveChangeConfirmDialog from './dialog.approveChangeConfirmDialog';
import denyChangeConfirmDialog from './dialog.denyChangeConfirmDialog';
import syncableBatchChange from '../syncNewRecommended/syncableBatchChange';

class dialogService {
  getOptions($event, {
    newChanges, changedIds, isNew, changesAreRecommended
  }) {
    return {
      controller,
      controllerAs: 'newRecommendedChangesDialogVM',
      locals: {
        newChanges,
        changedIds,
        isNew,
        changesAreRecommended
      },
      targetEvent: $event,
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.newRecommendedChangesDialog', [
  alerts,
  confirmDialog,
  pmDataService,
  loaderService,
  constants,
  ssDialogService,
  syncNewRecommended,
  approveChangeConfirmDialog,
  denyChangeConfirmDialog,
  syncableBatchChange
])
  .service('newRecommendedChangesDialog', dialogService)
  .name;
